const initialState = {
    selectedApms: {},
    selectedClusters: {},
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'SET_SELECTED_APM') {
        const hasSelectedDevice = action.payload.devices.some(({ selected }) => selected);
        if (hasSelectedDevice) {
            return {
                ...state,
                selectedApms: {
                    ...state.selectedApms,
                    [action.payload.id]: action.payload,
                },
            };
        }
        const selectedApms = { ...state.selectedApms };
        delete selectedApms[action.payload.id];
        return {
            ...state,
            selectedApms,
        };
    }

    if (action.type === 'REMOVE_SELECTED_APM') {
        const selectedApms = { ...state.selectedApms };
        delete selectedApms[action.payload];
        return {
            ...state,
            selectedApms,
        };
    }

    if (action.type === 'RESET_SELECTED_APMS') {
        return {
            ...state,
            selectedApms: {},
        };
    }

    if (action.type === 'SET_SELECTED_CLUSTER') {
        const hasSelectedServer = action.payload.servers.some(({ selected }) => selected);
        if (hasSelectedServer) {
            return {
                ...state,
                selectedClusters: {
                    ...state.selectedClusters,
                    [action.payload.id]: action.payload,
                },
            };
        }
        const selectedClusters = { ...state.selectedClusters };
        delete selectedClusters[action.payload.id];
        return {
            ...state,
            selectedClusters,
        };
    }

    if (action.type === 'REMOVE_SELECTED_CLUSTER') {
        const selectedClusters = { ...state.selectedClusters };
        delete selectedClusters[action.payload];
        return {
            ...state,
            selectedClusters,
        };
    }

    if (action.type === 'RESET_SELECTED_CLUSTERS') {
        return {
            ...state,
            selectedClusters: {},
        };
    }

    return state;
}

export default reducer;
